/*@flow*/
import { local as store } from 'lib/storage';
import truthy from 'lib/truthy';

export function readJson(key: string): any {
  return JSON.parse(read(key) || null);
}

export function writeJson(key: string, value: ?{}) {
  write(key, JSON.stringify(value));
}

export const read = (key: string): any => store.getItem(key);

export const write = (key: string, data: ?string) => {
  store.setItem(key, data);
};

export const toggle = (key: string) => {
  truthy(store.getItem(key))
    ? store.setItem(key, 'false')
    : store.setItem(key, 'true');
};

export const remove = (key: string): any => store.removeItem(key);
